import * as React from 'react';
import ContentContainer from 'nomst/Components/SharedJobCollab/contentContainer';
import ListItem from 'nomst/Components/SharedJobCollab/listItem';
import ScrollableList from 'nomst/Components/SharedJobCollab/scrollableList';
import { mxStrings } from 'utils/JobCollabStrings';
import EmployeeCard from 'nomst/Components/EmployeesListView/employeeCard';
import { employeeList } from 'utils/MobxDataManager/singletons';
import { Employee } from 'nomst/Stores/Decision/employee';
import { observer } from 'mobx-react';
import { IEmployee } from 'typings/employee';
import './employeesListView.scss';

const tempEmployeesToShow = 5;
const defaultEEData: IEmployee = {
    firstName: '-xxxxxxx',
    lastName: '-xxxxxxxx',
    jobTitleInternal: 'Xxxxxxxxxx Xxxxxxxx Xxxxxxxx',
    employeeSourceId: '',
    isoCurrencyCode: 'USD',
    payHistory: null
};

interface EmployeesListViewProps {

}

// TypeScript voodoo to specialize generic class and use in JSX
type EmployeeList = new () => ScrollableList<Employee>;
// tslint:disable-next-line variable-name
const EmployeeList = ScrollableList as EmployeeList;

@observer
class EmployeesListView extends React.PureComponent<{}, {}> {
    private _renderItemFunc: (eeData: Employee, index?: number) => React.ReactNode;

    constructor(props: EmployeesListViewProps) {
        super(props);
        // cache this off so we don't create a new function each time we render,
        // messing up shallow comparisons of props
        this._renderItemFunc = ((eeData: Employee, index: number) => this._renderEmployee(eeData, index));
    }

    render(): React.ReactNode {
        const { employees } = employeeList;
        const noEmployeesInList = employeeList.employeesFetched && employees.length === 0;
        return (
            <div className="employees-list-view tjc-page">
                <ContentContainer>
                    { !noEmployeesInList &&
                        <h1 className="employees-list-view__heading">{mxStrings.employees}</h1> }
                </ContentContainer>
                <ContentContainer nopadding={true}>
                    { this._renderEmployeeList(employees.length, employees, noEmployeesInList) }
                </ContentContainer>
            </div>
        );
    }

    private _renderEmployee(eeData: Nullable<IEmployee>, index?: number): React.ReactNode {
        const defaultData = !eeData;
        eeData = eeData || defaultEEData;

        return (
            <ListItem key={eeData.employeeSourceId || `temp_${index}`}>
                <EmployeeCard
                    id={eeData.employeeSourceId}
                    firstName={eeData.firstName}
                    lastName={eeData.lastName}
                    detail={eeData.jobTitleInternal || ' '} // ensure at least a space so heights are consistent
                    className={defaultData ? 'placeholder' : '' }
                />
            </ListItem>
        );
    }

    private _renderEmployeeList(
        employeeCount: number,
        employees: Nullable<Employee[]>,
        noEmployeesInList: Nullable<boolean>): React.ReactNode {
        if (noEmployeesInList) {
            return (
                <div className="no-list-items">
                    <img src={require('contents/no_team.svg')} className="no-list-items-img" alt=""/>
                    <div className="no-list-items-header">
                        { mxStrings.noEmployeesHeader }
                    </div>
                    <div className="no-list-items-body">
                        { mxStrings.noEmployeesBody }
                    </div>
                </div>
            );
        }

        // build up placeholder data if none provided
        if (!employees?.length) {
            employeeCount = employeeCount || tempEmployeesToShow;
            employees = Array(employeeCount).fill(null);
        }

        return (
            <EmployeeList
                className="employees-container"
                items={employees}
                renderItemFunc={this._renderItemFunc}
            />
        );
    }
}

export { EmployeesListView };
export default EmployeesListView;
